import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useFeederMarkets(
  userId: string,
  dateRange: { startDate: string; endDate: string },
) {
  return useQuery({
    queryKey: ["feeder-markets", userId, dateRange.startDate, dateRange.endDate],
    queryFn: () =>
      api.getAnalytics(userId, {
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        analyticsType: "FeederMarkets",
      }),
    enabled: !!userId && !!dateRange.startDate && !!dateRange.endDate,
    staleTime: 5 * 60 * 1000,
  });
}
